import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
  };

  const baseBtn = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 999,
    border: 'none',
    background: 'transparent',
    color: '#64748b',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    transition: 'all 0.18s ease',
  };

  const activeBtn = {
    ...baseBtn,
    background: '#ffffff',
    color: '#b45309',
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 9999,
        display: 'flex',
        gap: 4,
        padding: 4,
        background: 'rgba(241, 245, 249, 0.9)',
        backdropFilter: 'blur(8px)',
        border: '1px solid #e5e7eb',
        borderRadius: 999,
        boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
      }}
    >
      <button
        onClick={() => setLang('en')}
        aria-label="Switch to English"
        style={i18n.language === 'en' ? activeBtn : baseBtn}
      >
        🇬🇧 EN
      </button>
      <button
        onClick={() => setLang('nl')}
        aria-label="Wissel naar Nederlands"
        style={i18n.language === 'nl' ? activeBtn : baseBtn}
      >
        🇳🇱 NL
      </button>
    </div>
  );
}


